import React from "react";
import { UserSummary, FamilySummary, ParticipantSummary } from "../../../../gql/types";
import BaseListView from "../../../overlay/BaseListView";
import happyFaceIcon from "../../../../assets/icons/purpleHappyFace.svg";
import styles from "./PlaydateInviteGuestListView.module.css";
import PortalRoot from "../../../portal/PortalRoot";
import { ProfileRowPlacementType } from "../../../profile/ProfileDetailRow";
import ParticipantSummaryRow from "../../ParticipantSummaryRow";
import { OverlayOpacity } from "../../../portal/types";

export type PlaydateInviteGuestListViewProps = {
    guests: ParticipantSummary[];
    onBack: () => void;
    isPortal?: boolean;
    baseZIndex?: number;
};


const longGuestList: UserSummary[] = Array.from({ length: 50 }, (_, index) => ({
    id: (index + 1).toString(),
    email: `guest@email.com`,
    firstName: `Guest`,
    lastName: `${index + 1}`,
    // Add other properties as required by your UserSummary type and ProfileDetaileRow component
}));


const PlaydateInviteGuestListView: React.FC<PlaydateInviteGuestListViewProps> = ({
    guests,
    onBack,
    isPortal,
    baseZIndex,
}) => {
    const header = (
        <div className={styles.guestListHeader}>
            <div className={styles.iconContainer}>
                <img src={happyFaceIcon} className={styles.confirmationIcon} />
            </div>
            <div className={styles.infoSection}>Please review the guest list below.</div>
            <div className={styles.divider} />
        </div>
    );

    if (isPortal) {
        return (
            <PortalRoot overlayOpacity={OverlayOpacity.TRANSPARENT} baseZIndex={baseZIndex}>
                <BaseListView
                    onClose={onBack}
                    baseZIndex={baseZIndex}
                    headerContent={header}
                >
                    <div className={styles.guestListScrollContainer}>
                        {guests.map((guest) => (
                            <ParticipantSummaryRow
                                key={"email" in guest ? guest.email : guest.id}
                                participant={guest}
                                placement={ProfileRowPlacementType.LIST}
                            />
                        ))}
                    </div>
                    <div className={styles.divider} />
                </BaseListView>
            </PortalRoot>
        );
    }

    return <BaseListView onClose={onBack}></BaseListView>;
};

export default PlaydateInviteGuestListView;
